import { Icon, IconProps } from "./Icon";

export function IconPlacemarker(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="m12 24-.41-.58C11.25 23 4 12.6 4 8.22A8.13 8.13 0 0 1 12 0a8.13 8.13 0 0 1 8 8.23c0 4.37-7.31 14.77-7.62 15.18Zm0-23a7.13 7.13 0 0 0-7 7.22c0 3.5 5.45 11.74 7 14 1.55-2.28 7-10.52 7-14A7.13 7.13 0 0 0 12 1Zm0 3a4 4 0 1 0 4 4 4 4 0 0 0-4-4Zm0 7a3 3 0 1 1 3-3 3 3 0 0 1-3 3Z" />
    </Icon>
  );
}
